import { Component, OnInit, ViewChild } from '@angular/core';
import { Maintenance } from '../../../../../entities/maintenance.model';
import { MaintenanceService } from '../../../../../shared/services/maintenance.service';
import * as moment from 'moment';
import { deserialize } from 'json-typescript-mapper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';

@Component({
  selector: 'app-administration-maintenance',
  templateUrl: './administration-maintenance.component.html',
  styles: []
})
export class AdministrationMaintenanceComponent implements OnInit {

  maintenances: Array<Maintenance>;
  selectedMaintenances: Array<boolean>;
  maintenance: Maintenance;
  modalRef: NgbModalRef;
  @ViewChild('maintenanceModal') private maintenanceModal;

  constructor(private maintenanceService: MaintenanceService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.maintenances = this.maintenanceService.getMaintenances() || [];
    this.selectedMaintenances = this.maintenances.map(() => false);
    this.maintenanceService.maintenancesChanged.subscribe((maintenances: Array<Maintenance>) => {
      this.maintenances = maintenances;
      this.selectedMaintenances = this.maintenances.map(() => false);
    });
  }

  someMaintenancesSelected(): boolean {
    return this.selectedMaintenances && this.selectedMaintenances.some(s => s);
  }

  removeMaintenance(index: number = null) {
    if (index !== null) {
      this.maintenanceService.removeMaintenance(this.maintenances[index])
        .then().catch(e => console.log('could not remove maintenance:', e));
    } else if (this.selectedMaintenances.some(selected => selected)) {
      this.selectedMaintenances.forEach((selected, i) => {
        if (selected) {
          this.maintenanceService.removeMaintenance(this.maintenances[i])
            .then().catch(e => console.log('could not remove maintenance:', e));
        }
      });
    }
  }

  editMaintenance(index: number = null) {
    if (index !== null) {
      this.maintenance = deserialize<Maintenance>(Maintenance, {
        id: this.maintenances[index].id,
        startDate: moment(this.maintenances[index].startDate).format('YYYY-MM-DD'),
        endDate: (this.maintenances[index].endDate)
          ? moment(this.maintenances[index].endDate).format('YYYY-MM-DD') : null,
        startTime: this.maintenances[index].startTime,
        endTime: this.maintenances[index].endTime,
        type: this.maintenances[index].type,
        message: this.maintenances[index].message,
        announcement: this.maintenances[index].announcement,
        announcementStart: (this.maintenances[index].announcementStart)
          ? moment(this.maintenances[index].announcementStart).format('YYYY-MM-DDTHH:mm') : null,
        created: this.maintenances[index].created,
        updated: this.maintenances[index].updated,
        createdByContactId: this.maintenances[index].createdByContactId,
        updatedByContactId: this.maintenances[index].updatedByContactId,
      });
    } else {
      this.maintenance = deserialize<Maintenance>(Maintenance, {
        id: null,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        startTime: moment().format('HH:mm'),
        endTime: moment().format('HH:mm'),
        type: 'regular',
        message: '',
        announcement: null,
        announcementStart: null,
        created: null,
        updated: null,
        createdByContactId: null,
        updatedByContactId: null,
      });
    }

    this.modalRef = this.modalService.open(this.maintenanceModal, {backdrop: 'static'});
  }

  cancelMaintenance() {
    this.modalRef.close();
    this.maintenance = null;
  }

  saveMaintenance() {
    if (this.maintenance) {
      const maintenance: Maintenance = deserialize<Maintenance>(Maintenance, Object.assign({}, this.maintenance));
      maintenance.startDate = new Date(new Date(this.maintenance.startDate).setHours(0, 0, 0)).toISOString();
      maintenance.endDate = (this.maintenance.endDate && this.maintenance.endDate !== '')
        ? new Date(new Date(this.maintenance.endDate).setHours(23, 59, 59)).toISOString() : null;
      maintenance.announcementStart = (this.maintenance.announcementStart && this.maintenance.announcementStart !== '')
        ? new Date(this.maintenance.announcementStart).toISOString() : null;
      this.maintenanceService.saveMaintenance(maintenance).then(() => {
        this.modalRef.close();
        this.maintenance = null;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/components/administration/components/administration-maintenance/administration-maintenance.component.ts